export default __webpack_public_path__ + "static/media/No.9-1.7aa17ad9.jpg";